var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.loading)?_c('highcharts',{attrs:{"options":_vm.options}}):_c('v-progress-circular',{attrs:{"value":20,"indeterminate":"","color":"#704DFA"}})
}
var staticRenderFns = []

export { render, staticRenderFns }